// src/components/common/LoadingSpinner.js
import React from 'react';

const LoadingSpinner = ({ fullScreen = false, message }) => (
    <div className={`flex flex-col items-center justify-center ${fullScreen ? 'h-screen' : 'h-full'}`}>
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-600 mb-4"></div>
        {message && (
            <h3 className="text-[#18216D] font-black tracking-tight text-lg">{message}</h3>
        )}
    </div>
);

export default LoadingSpinner;